import React, { LazyExoticComponent } from "react";

/**
 * safeLazy : wrapper autour de React.lazy pour gérer les erreurs de chargement de chunks.
 * @param importFunc - Fonction retournant une promesse d'import dynamique d'un composant React.
 * @returns LazyExoticComponent<T>
 */
// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export function safeLazy<T extends React.ComponentType<any>>(
  importFunc: () => Promise<{ default: T }>,
): LazyExoticComponent<T> {
  return React.lazy(
    () =>
      importFunc().catch((error) => {
        const isChunkLoadError =
          error &&
          (error.name === "ChunkLoadError" ||
            /Loading chunk [\d]+ failed/.test(error.message) ||
            /Failed to fetch dynamically imported module/.test(error.message));

        if (isChunkLoadError) {
          if (!sessionStorage.getItem("chunkLoadErrorReloaded")) {
            sessionStorage.setItem("chunkLoadErrorReloaded", "1");
            window.location.reload();
          } else {
            sessionStorage.removeItem("chunkLoadErrorReloaded");
          }
        }
        throw error;
      }) as Promise<{ default: T }>,
  );
}
